import { render, staticRenderFns } from "./ReviewBox.vue?vue&type=template&id=330ea1ce&scoped=true"
import script from "./ReviewBox.vue?vue&type=script&lang=js"
export * from "./ReviewBox.vue?vue&type=script&lang=js"
import style0 from "./ReviewBox.vue?vue&type=style&index=0&id=330ea1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ea1ce",
  null
  
)

export default component.exports